module.exports = __webpack_public_path__ + "img/11-1.0cc92dfb.png";